import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Infographic from './Infographic';
import Multiplechoice from './Multiplechoice';
import Summary from './Summary';
import Open from './Open';
import Loader from '../../../components/core/Loader';
import { getCourse, getLesson } from '../../../redux/actions/elearningActions';
import Navigation from './Navigation';
import Video from './Mp4';

function Module({ item }) {
  if (!item) return;

  const commonProps = { item, key: item._id };
  switch (item.type) {
    case 'infographic':
      return <Infographic {...commonProps} />;
    case 'multiplechoice':
      return <Multiplechoice {...commonProps} />;
    case 'summary':
      return <Summary {...commonProps} />;
    case 'open':
      return <Open {...commonProps} />;
    case 'mp4':
      return <Video {...commonProps} />;
    default:
      throw new Error(`${item.type} is not a valid component type`);
  }
}

Module.propTypes = {
  item: PropTypes.objectOf({
    type: PropTypes.string,
  }).isRequired,
};

function LessonRouter() {
  const dispatch = useDispatch();
  const { courseId, lessonId, itemIndex } = useParams();
  const course = useSelector((state) => state.elearning.selectedCourse);
  const lesson = useSelector((state) => state.elearning.selectedLesson);

  const currentPage = Number.parseInt(itemIndex, 10);

  useEffect(() => {
    dispatch(getCourse(courseId));
    dispatch(getLesson(lessonId));
  }, []);

  if (!course || !lesson) {
    return <Loader />;
  }

  const item = lesson.items[currentPage];
  return (
    <main className="m-5 flex flex-col space-y-5">
      <div className="flex flex-col">
        <h1 className="font-bold text-grey-dark text-lg">{course.title}</h1>
        <h2 className="font-normal text-grey-medium text-base">
          {lesson.title}
        </h2>
      </div>
      <Module item={item} />
      <Navigation currentPage={currentPage} pageCount={lesson.items.length} />
    </main>
  );
}

export default LessonRouter;
